import styled from "styled-components"

export const ListRow = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0.5em 1em;
  justify-content: space-between;
`
